import { iCateNode, SET_CATE_TREE } from "./type";



function setCateTree(cateTree: iCateNode[]) {
    return {
        type: SET_CATE_TREE,
        payload: cateTree
    };
}

export {
    setCateTree,
}